import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { environment } from "@environments/environment";
import { User } from "../_models/user";
import conf from "../_models/conf.json";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  //public urlApi = 'http://localhost:8000/index.php/'; // prod
  // public urlApi = "https://nextsysplay-api.mncplay.id/frontend/web/index.php/"; // dev
  // public urlApi = conf.urlApilocal; // local
  public urlApi = conf.urlApidev; // dev
  // public urlApi = conf.urlApiprod; // prod

  //staging
  //public urlApi = 'http://b2b-api-dev.mncplaymedia.com/frontend/web/index.php/';
  //public urlApi = 'https://b2b-api-dev.mncplay.id/frontend/web/index.php/';

  //production local
  //public urlApi = 'http://b2b-api.mncplaymedia.com/frontend/web/index.php/';

  //production public
  //public urlApi = 'https://b2b-api.mncplay.id/frontend/web/index.php/';

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private c = conf;
  public conf = conf;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUserB2B2C"))
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public setcurrentUserValue(data): User {
    localStorage.setItem("currentUserB2B2C", JSON.stringify(data));
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUserB2B2C"))
    );
    this.currentUserSubject.next(data);

    return this.currentUserSubject.value;
  }

  login(data: any) {
    return this.http.post<any>(this.urlApi + "apis/login", data).pipe(
      map((user) => {
        // console.log(user);
        // login successful if there's a jwt token in the response
        if (user.status) {
          if (user.data) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes

            localStorage.setItem("currentUserB2B2C", JSON.stringify(user.data));
            this.currentUserSubject.next(user.data);
          }
        }
        return user;
      })
    );
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem("currentUserB2B2C");
    this.currentUserSubject.next(null);
  }
}
